export interface ScannerFrameProps {
  /** idle = breathing brackets (the one allowed loop); detect = converge + success. */
  state?: 'idle' | 'detect';
  /** Frame square edge in px (brief: 240 — tight frame reads as "get close"). */
  size?: number;
  /** Accessible name; decorative when omitted. */
  label?: string;
  className?: string;
}

/**
 * The lock-on viewfinder frame (brief §6 "Scanner"): four corner brackets marking
 * a square. Idle: --fg at 90%, breathing ±2% over 2.4s. Detect: brackets converge
 * (scale 0.92 over 150ms) and turn --success. Reduced motion: static.
 */
export function ScannerFrame({ state = 'idle', size = 240, label, className = '' }: ScannerFrameProps) {
  const arm = 34; // bracket arm length in a 120-unit quadrant, tuned to the app icon's proportions
  const r = 12;
  const d = [
    `M8 ${8 + arm} V${8 + r} a${r} ${r} 0 0 1 ${r} -${r} H${8 + arm}`,
    `M${112 - arm} 8 H${112 - r} a${r} ${r} 0 0 1 ${r} ${r} V${8 + arm}`,
    `M112 ${112 - arm} V${112 - r} a${r} ${r} 0 0 1 -${r} ${r} H${112 - arm}`,
    `M${8 + arm} 112 H${8 + r} a${r} ${r} 0 0 1 -${r} -${r} V${112 - arm}`,
  ].join(' ');
  return (
    <svg
      viewBox="0 0 120 120"
      width={size}
      height={size}
      role={label ? 'img' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
      data-testid="ec-scanner-frame"
      data-state={state}
      className={`${state === 'idle' ? 'ec-breathe text-fg/90' : 'ec-converge text-success'} ${className}`}
      fill="none"
      stroke="currentColor"
      strokeWidth="6"
      strokeLinecap="round"
    >
      <path d={d} />
    </svg>
  );
}
